export default "/assets/images/gup-logo.png"